const IconPlus = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 xl:h-6 w-5 xl:w-6 select-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
    </svg>
  );
};
export default IconPlus;
